export const fetchRetryParameters = {
  retryDelay: 100,
  timeout: 60000,
}

export type RequestHostHeadersType = 'cookie' | 'x-forwarded-host' | 'host'
export const requestHostHeaders = ['cookie', 'x-forwarded-host', 'host'] as Array<RequestHostHeadersType>
